import React from 'react';
import YouTubePlayer from './YouTubePlayer';
import PDFViewer from './PDFViewer';
import ImageViewer from './ImageViewer';
import { LearningContent, LearningContentType } from '../../types';

// Export the enum for backward compatibility
export { LearningContentType as ContentType };

interface ContentViewerProps {
  isOpen: boolean;
  onClose: () => void;
  content: LearningContent | null;
}

const ContentViewer: React.FC<ContentViewerProps> = ({ isOpen, onClose, content }) => {
  if (!content) return null;

  // For VIDEO content type, use the existing YouTubePlayer
  if (content.contentType === LearningContentType.VIDEO && content.url) {
    // Convert to the format expected by YouTubePlayer
    const videoData = {
      id: content.id,
      title: content.title,
      url: content.url,
      sectionId: content.section?.id || '',
      section: content.section,
      createdAt: content.createdAt,
      updatedAt: content.createdAt, // Use createdAt as fallback
    };

    return (
      <YouTubePlayer
        isOpen={isOpen}
        onClose={onClose}
        video={videoData}
      />
    );
  }

  // For file-based content, create content data for file-based viewers
  // The viewers will use the content ID to fetch files via the API
  const fileContent = {
    ...content,
    fileUrl: `/learning/content/${content.id}/file`, // This is used as a fallback, but viewers use the API
  };

  // Render appropriate viewer based on content type
  switch (content.contentType) {
    case LearningContentType.PDF:
      return (
        <PDFViewer
          isOpen={isOpen}
          onClose={onClose}
          content={fileContent}
        />
      );



    case LearningContentType.IMAGE:
      return (
        <ImageViewer
          isOpen={isOpen}
          onClose={onClose}
          content={fileContent}
        />
      );

    default:
      return null;
  }
};

export default ContentViewer;
